export default __webpack_public_path__ + "static/rails-481a5c28cea5c7da105a977a1d55f8da.svg";